import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './assets/global.scss';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store, { persistor } from './store/appStore/store';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-tooltip/dist/react-tooltip.css';
import * as Sentry from '@sentry/react';

Sentry.init({
	dsn: process.env.REACT_APP_SENTRY_DSN,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<Sentry.ErrorBoundary fallback={<p>Something went wrong</p>}>
		<Provider store={store}>
			<PersistGate
				loading={null}
				persistor={persistor}
			>
				<>
					<ToastContainer
						position="top-center"
						autoClose={5000}
						hideProgressBar={false}
						newestOnTop={false}
						closeOnClick
						rtl={false}
						pauseOnFocusLoss
						draggable
						pauseOnHover
						theme="light"
					/>
					<App />
				</>
			</PersistGate>
		</Provider>
	</Sentry.ErrorBoundary>,
);

reportWebVitals();
